// extracted by mini-css-extract-plugin
module.exports = {"large":"TotalItems_large__ggJT_","small":"TotalItems_small__ZSb_0"};